import { useState } from 'react';
import { When } from 'react-if';
import { Button } from '../../../../common/view/button/button/button';
import { Color } from '../../../../common/view/color/color';
import { MonoIcon } from '../../../../common/view/icon/mono/mono-icon';
import { CssFuncs } from '../../../../foundation/css/css.funcs';
import { DesktopTodayStyle } from './desktop-today.style';
import { Today } from './today';

export function DesktopToday() {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <DesktopTodayStyle.Container
      className={CssFuncs.className((names) => {
        names.push(collapsed ? 'collapsed' : 'not-collapsed');
      })}
    >
      <When condition={!collapsed}>
        <Today onClickCollapse={() => setCollapsed(!collapsed)} />
      </When>
      <When condition={collapsed}>
        <Button icon={MonoIcon.today} size={24} color={Color.white8} onClick={() => setCollapsed(!collapsed)} />
      </When>
    </DesktopTodayStyle.Container>
  );
}
